export class Ativo {
  constructor({
    ativoUuid,
    codigo,
    descricao,
    grupo,
    subgrupo,
    url,
    tempoPermanencia,
    atributos,
    checkLists,
    unidadeMedida,
    acessorios,
    valor,
    fornecedorId,
    origem,
    status,
    patrimonio,
    deposito,
    documentoNumero,
    documentoSerie,
    documentoTipo,
    reponsavelId,
    documentosVinculados,
    fornecedorNome,
  }) {
    this.ativoUuid = ativoUuid;
    this.codigo = codigo;
    this.descricao = descricao;
    this.grupo = grupo;
    this.subgrupo = subgrupo;
    this.url = url;
    this.valor = valor;
    this.tempoPermanencia = tempoPermanencia;
    this.atributos = atributos;
    this.checkLists = checkLists;
    this.status = status;
    this.unidadeMedida = unidadeMedida;
    this.acessorios = acessorios;
    this.deposito = deposito;
    this.fornecedorId = fornecedorId;
    this.patrimonio = patrimonio;
    this.documentoNumero = documentoNumero;
    this.documentoSerie = documentoSerie;
    this.documentoTipo = documentoTipo;
    this.responsavelId = reponsavelId;
    this.origem = origem;
    this.documentosVinculados = documentosVinculados;
    this.fornecedorNome = fornecedorNome;
  }
}
